// Sticky-nav behavior: mobile menu toggle + scroll-spy active link.

export function initNav(doc = document) {
  const header = doc.querySelector(".topnav")
  if (!header) return

  const toggle = header.querySelector(".menu-toggle")
  const links = header.querySelectorAll("nav a")

  toggle.addEventListener("click", () => {
    const open = header.dataset.menuOpen === "true"
    header.dataset.menuOpen = String(!open)
    toggle.setAttribute("aria-expanded", String(!open))
  })

  // Collapse the mobile menu after following an in-page link.
  links.forEach((link) =>
    link.addEventListener("click", () => {
      header.dataset.menuOpen = "false"
      toggle.setAttribute("aria-expanded", "false")
    })
  )

  // Highlight the nav link for the section currently in view.
  const sections = doc.querySelectorAll("main section[id]")
  if (!sections.length) return

  const highlight = () => {
    let current = ""
    sections.forEach((section) => {
      if (window.scrollY >= section.offsetTop - 120) current = section.id
    })
    links.forEach((link) => {
      const active = link.getAttribute("href") === `#${current}`
      if (active) link.setAttribute("aria-current", "true")
      else link.removeAttribute("aria-current")
    })
  }

  window.addEventListener("scroll", highlight, { passive: true })
  highlight()
}
